import { useState, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import TendersList from './components/TendersList'
import Filters from '../../shared/components/filters/Filters'

const TendersPage = () => {
  const [searchParams] = useSearchParams()

  // Get filters from URL parameters (similar to NoticeList)
  const filters = {
    order_object: searchParams.get('order_object') || '',
    organization_name: searchParams.get('organization_name') || '',
    cpv_code: searchParams.get('cpv_code') || '',
    notice_types: searchParams.getAll('notice_types'),
    organization_city: searchParams.get('organization_city') || '',
    organization_province: searchParams.get('organization_province') || '',
    client_type: searchParams.get('client_type') || '',
    order_type: searchParams.get('order_type') || '',
    tender_type: searchParams.get('tender_type') || '',
    is_tender_amount_below_eu:
      searchParams.get('is_tender_amount_below_eu') === 'true' ? true : null,
    procedure_result: searchParams.get('procedure_result') || '',
    bzp_number: searchParams.get('bzp_number') || '',
    date_from: searchParams.get('date_from') || '',
    date_to: searchParams.get('date_to') || '',
  }

  const handleNoticeClick = (noticeId: string) => {
    // Navigate to detail page with current filters
    window.location.href = `/tenders/${noticeId}${searchParams.toString() ? '?' + searchParams.toString() : ''}`
  }

  return (
    <div className="space-y-6">
      <div className="bg-surface-raised rounded-lg border border-border-subtle p-6">
        <h1 className="text-2xl font-bold text-ink mb-2">Ogłoszenia</h1>
        <p className="text-ink-secondary">
          Lista wszystkich ogłoszeń przetargowych - wyszukiwanie, filtrowanie i przeglądanie
          szczegółów
        </p>
      </div>

      <Filters />

      <TendersList filters={filters} onNoticeClick={handleNoticeClick} />
    </div>
  )
}

export default TendersPage
